import clsx from 'clsx';

export interface LoaderProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  title?: string;
  content?: string;
  useAsOverlay?: boolean;
}

export default function Loader({ size = 'md', title, content, useAsOverlay = false }: LoaderProps) {
  const containerStyles = clsx({
    'absolute flex z-[1000] h-full w-full bg-mono-1': useAsOverlay,
    'inline-flex flex-col': !useAsOverlay,
  });

  const styles = clsx('rounded-full bg-primary-2', {
    'h-4 w-4 mt-1': size === 'sm',
    'h-6 w-6': size === 'md',
    'h-8 w-8 mt-2': size === 'lg',
    'h-12 w-12 mt-2': size === 'xl',
  });
  const titleSize = clsx('', {
    'text-base mb-1 font-medium': size === 'sm',
    'text-lg mb-2 font-medium': size === 'md',
    'text-2xl mb-2 font-semibold': size === 'lg',
    'text-4xl mb-4 font-semibold': size === 'xl',
  });
  const contentSize = clsx('text-base mb-2', {
    'mb-3': size === 'sm',
    'mb-5': size === 'md',
    'mb-4': size === 'lg',
    'text-lg mb-4': size === 'xl',
  });
  return (
    <div className={containerStyles}>
      {title && <h1 className={`text-center text-primary-2 ${titleSize}`}>{title}</h1>}
      {content && <p className={`text-center ${contentSize}`}>{content}</p>}
      <div className="flex w-full items-center justify-center space-x-1 ">
        <span className={`animate-pulse ${styles}`} />
        <span className={`animate-pulse-delay-short ${styles}`} />
        <span className={`animate-pulse-delay-long ${styles}`} />
      </div>
    </div>
  );
}
